import { createContext, useContext } from 'react';

export const INCOME_PROTECTION_DA_CONTEXTS = {
  SCREEN: 'SCREEN',
} as const;

type IncomeProtectionDaContextType = {
  context: (typeof INCOME_PROTECTION_DA_CONTEXTS)[keyof typeof INCOME_PROTECTION_DA_CONTEXTS] | null;
};

export const IncomeProtectionDaContext = createContext<IncomeProtectionDaContextType>({ context: null });

export const useIsInsideIncomeProtectionDaScreen = (): boolean => {
  const { context } = useContext(IncomeProtectionDaContext);
  return Boolean(context);
};
